import Alpine from 'alpinejs';
import { ExpressQuotationRules } from '../../types/form';
import { iodine } from '../../helpers/validation';
import { FormFieldValidationAlpine, getFieldValidation } from '../../helpers/fieldValidation';
import { ExpressFormAlpine, getExpressSteps } from '../../helpers/expressSteps';
import { storeLocatorAutocomplete } from "../../helpers/storeLocator";

interface ExpressQuotationFormAlpine extends ExpressFormAlpine {
    form: HTMLFormElement;
    thirdStepQuotation: () => void;
    fourthStepQuotation: () => void;
}

const rules: ExpressQuotationRules = {
    firstname: ['required', 'noNumber'],
    lastname: ['required', 'noNumber'],
    address: ['required', 'leastOneLetter'],
    zip: ['required', 'zipOrCity'],
    phone: ['required', 'trybaPhone'],
    email: ['required', 'email', 'noPlusInEmail'],
    projectType: ['required'],
    phone_custom: ['required', 'justNumber'],
    city: ['required'],
    zip_no_autocomplete: ['required'],
};

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('initQuotationForm', (form: HTMLFormElement, fromLanding = false): ExpressQuotationFormAlpine & ExpressFormAlpine & FormFieldValidationAlpine => {
        return {
            isFromLanding: fromLanding,
            ...getFieldValidation(rules),
            ...getExpressSteps(form, rules, fromLanding),
            ...{
                form,
                thirdStepQuotation(verifyMobile  = true) {
                    const phone = verifyMobile ? this.$refs.phone as HTMLInputElement : this.$refs.phone_custom as HTMLInputElement;
                    const email = this.$refs.email as HTMLInputElement;
                    if (verifyMobile === true) {
                        const validation = iodine.assert(
                            {
                                phone: phone.value,
                                email: email.value,
                            },
                            {
                                phone: rules.phone,
                                email: rules.email,
                            },
                        );
                        if (validation.valid) {
                            this.validationError = false
                        }
                        this.checkValidation(validation);
                    } else {
                        const validation = iodine.assert(
                            {
                                phone_custom: phone.value,
                                email: email.value,
                            },
                            {
                                phone_custom: rules.phone_custom,
                                email: rules.email,
                            },
                        );
                        this.checkValidation(validation);
                    }
                },

                thirdStepQuotationZip(verifyMobile  = true) {

                    const phone = verifyMobile ? this.$refs.phone as HTMLInputElement : this.$refs.phone_custom as HTMLInputElement;
                    const email = this.$refs.email as HTMLInputElement;
                    const zipCode = this.form.querySelector('[name$="[zip]"]') as HTMLInputElement;
                    let validAdress = false;
                    storeLocatorAutocomplete(zipCode.value)
                        .then((cities) => {
                            this.results = cities;
                            const allResult = (this.results = JSON.parse(JSON.stringify(this.results)));
                            allResult.forEach((el) => {
                                if (el.codesPostaux.length > 1)
                                    el.codesPostaux.forEach((subEl) => {
                                        const result = subEl + ' ' + el.nom;
                                        if (zipCode?.value == result) {
                                            validAdress = true;
                                        }
                                    });
                                else {
                                    const result = el.codesPostaux[0] + ' ' + el.nom;
                                    if (zipCode?.value == result) {
                                        validAdress = true;
                                    }
                                }
                            });
                            this.thirdStepValidation(verifyMobile, validAdress, zipCode, phone, email);
                        })
                        .catch(() => {
                            this.thirdStepValidation(verifyMobile, validAdress, zipCode, phone, email);
                        });
                },
                thirdStepValidation(verifyMobile, validAdress, zipCode, phone, email, ) {
                    if (verifyMobile === true) {
                        const validation = iodine.assert(
                            {
                                phone: phone.value,
                                email: email.value,
                                zip: validAdress ? zipCode.value : null,
                            },
                            {
                                phone: rules.phone,
                                email: rules.email,
                                zip: rules.zip,
                            },
                        );
                        this.checkValidation(validation);
                    } else {
                        const validation = iodine.assert(
                            {
                                phone_custom: phone.value,
                                email: email.value,
                                zip: validAdress ? zipCode.value : null,
                            },
                            {
                                phone_custom: rules.phone_custom,
                                email: rules.email,
                                zip: rules.zip,
                            },
                        );
                        this.checkValidation(validation);
                    }
                },
                fourthStepQuotation() {
                    const projectType = this.$refs.projectType as HTMLSelectElement;
                    if (projectType === null || projectType === undefined) {
                        return; // we are on a landing page, so there is no projectType field, so no validation necessary
                    }
                    const validation = iodine.assert(
                        {
                            projectType: projectType.selectedOptions[0].value,
                        },
                        {
                            projectType: rules.projectType,
                        },
                    );
                    this.checkValidation(validation);
                },
            },
        };
    });
});
